import { Controller } from "@hotwired/stimulus"

// The step banners ("Missing: Client reference") and the tab badges
// ("1 to complete") are rendered by the server from the saved record. As
// the person fills a listed field, the banner sentence and the badge follow
// without a save: each missing name carries the input that clears it
// (data-field), the controller re-composes the sentence from the names still
// unfilled, and hides the banner when none remain. A name with no single
// field behind it (the checklist summary, "Operator (set on the aircraft)")
// stays until the server says otherwise, and the badge says "Ready after
// save" rather than claiming the step is done.
export default class extends Controller {
  static targets = ["banner", "text", "item", "sub"]

  connect() {
    this.onInput = this.onInput.bind(this)
    this.element.addEventListener("input", this.onInput)
    this.element.addEventListener("change", this.onInput)
  }

  disconnect() {
    this.element.removeEventListener("input", this.onInput)
    this.element.removeEventListener("change", this.onInput)
  }

  onInput(event) {
    const name = event.target?.name
    if (!name) return
    const items = this.itemTargets.filter((item) => item.dataset.field === name)
    if (!items.length) return
    const filled = (event.target.value || "").trim() !== ""
    items.forEach((item) => { item.dataset.filled = filled ? "1" : "0" })
    this.refresh(items[0].dataset.step)
  }

  refresh(step) {
    const remaining = this.itemTargets
      .filter((item) => item.dataset.step === step && item.dataset.filled !== "1")
      .map((item) => item.dataset.name)

    const banner = this.bannerTargets.find((b) => b.dataset.step === step)
    if (banner) {
      banner.hidden = remaining.length === 0
      const text = this.textTargets.find((t) => t.dataset.step === step)
      if (text) text.textContent = `${banner.dataset.prefix || ""}${remaining.join(", ")}`
    }

    const sub = this.subTargets.find((s) => s.dataset.step === step)
    if (sub) sub.textContent = remaining.length ? `${remaining.length} to complete` : "Ready after save"
  }
}
